import { CareServiceOrgansKey } from '@/api';
import { useCarePlanService } from '@/shared/guard';
import { useDefaultAndCommonFindings } from '@/shared/hook';
import { ReportLink } from '@/shared/model';
import { getFindingsWithHighScores } from '@/shared/util';

export function useOrganLinksWithHighScore() {
  const { links } = useCarePlanService();

  const defaultAndCommonFindings = useDefaultAndCommonFindings();
  const findingsWithHighScore = getFindingsWithHighScores(defaultAndCommonFindings);

  const linkMap = new Map<string, number>();
  const findingsLinks: ReportLink[] = [];

  links.forEach((link, index) => {
    linkMap.set(link.key, index);

    if (findingsWithHighScore[link.key as CareServiceOrgansKey]) {
      findingsLinks.push(link);
    }

    if (link?.sub) {
      link.sub.forEach((subOrganData) => {
        linkMap.set(subOrganData.key, index + linkMap.size * 0.001);

        if (findingsWithHighScore[subOrganData.key as CareServiceOrgansKey]) {
          findingsLinks.push(subOrganData);
        }
      });
    }
  });

  return { findingsLinks, findingsWithHighScore };
}
